import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {SearchClient, SearchParamsObject} from 'algoliasearch';
import {from, Observable} from 'rxjs';
import {ALGOLIA_TOKEN} from './algolia.token';

@Injectable({
  providedIn: 'root',
})
export class AlgoliaSearchService {
  private readonly algolia = inject(ALGOLIA_TOKEN);

  private readonly client: SearchClient;
  constructor() {
    const algolia = this.algolia;

    this.client = algolia(environment.algoliaSearch.applicationId, environment.algoliaSearch.searchApiKey);
  }

  multiIndexSearch(
    queries: Array<{
      indexName: string;
      query: string;
      params?: SearchParamsObject;
    }>
  ): Observable<any> {
    return from(
      this.client.search(
        queries.map(q => ({
          indexName: q.indexName,
          query: q.query,
          ...q.params,
        }))
      )
    );
  }
}
